<template>
  <main class="home" role="main">
    <section class="hero" role="banner">
      <div class="container hero__inner">
        <h1 class="hero__title do-not-translate">
          WOLFSBURGER <span>LUPE</span>
        </h1>
        <p class="hero__subtitle">Finde Angebote aus Bildung, Freizeit und Beratung.</p>

        <form class="hero__search" role="search" @submit.prevent="submitSearch">
          <label class="sr-only" for="home-search">Suchbegriff eingeben</label>
          <input id="home-search" v-model="searchTerm" type="search" name="search" autocomplete="off"
            aria-label="Suchbegriff eingeben" placeholder="Wonach suchst Du?" @keyup.enter.prevent="submitSearch" />
          <button type="submit">
            <span class="material-icons-outlined" aria-hidden="true">search</span>
            Finden
          </button>
        </form>
      </div>
    </section>

    <section class="home-categories" aria-label="Hauptkategorien">
      <div class="container">
        <div class="cards-grid" role="list">
          <router-link v-for="category in heroCategories" :key="category.title" class="hero-card"
            :class="category.className" :to="category.to" role="listitem">
            <div class="hero-card__circle">
              <img :src="category.icon" :alt="category.title" />
              <div class="hero-card__text">
                <span>{{ category.title }}</span>
              </div>
              <span class="hero-card__action" aria-hidden="true">
                <span class="material-icons-outlined">arrow_forward</span>
              </span>
            </div>
          </router-link>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      searchTerm: '',
      heroCategories: [
        {
          title: 'Beratung & Hilfe',
          className: 'hero-card--magenta',
          icon: '/assets/icons/hilfe.png',
          to: { name: 'Category', params: { category: 'Beratung & Hilfe' } },
        },
        {
          title: 'Freizeit',
          className: 'hero-card--yellow',
          icon: '/assets/icons/freizeit.png',
          to: { name: 'Category', params: { category: 'Freizeit' } },
        },
        {
          title: 'Aus- & Weiterbildung',
          className: 'hero-card--teal',
          icon: '/assets/icons/beruf.png',
          to: { name: 'Category', params: { category: 'Ausbildung & Weiterbildung' } },
        },
        {
          title: 'Kita- & Schulfinder',
          className: 'hero-card--orange',
          icon: '/assets/icons/kita.png',
          to: { name: 'BildungsFinder' },
        },
      ],
    };
  },
  methods: {
    submitSearch() {
      if (!this.searchTerm || this.searchTerm.trim() === '') {
        return;
      }
      this.$router.push({ name: 'Search', query: { keyword: this.searchTerm.trim() } });
    },
  },
};
</script>